// services/user.service.js
// import api from './api'
import { mockEvents, mockEventsProducts } from './mocks/event.mock.js'

export default {
  async getEvents() {
    // return api.get('/event/list')
    return Promise.resolve({ data: mockEvents })
  },
  async getEventById(id) {
    // return api.get(`/event/${id}`)
    for (let i = 0; i < mockEvents.length; i++) {
      if (mockEvents[i].id == id) {
        return Promise.resolve({ data: mockEvents[i] })
      }
    }

    return Promise.resolve({ data: null })
  },
  async getEventProducts(id) {
    // return api.get('/event/list-products')
    let eventProducts = [];

    for (let i = 0; i < mockEventsProducts.length; i++) {
      if (mockEventsProducts[i].event_id == id) {
        eventProducts.push(mockEventsProducts[i]);
      }
    }

    return Promise.resolve({ data: eventProducts })
  },
  // criar(dados) {
  //   return api.post('/usuarios', dados)
  // },
  // atualizar(id, dados) {
  //   return api.put(`/usuarios/${id}`, dados)
  // },
  // deletar(id) {
  //   return api.delete(`/usuarios/${id}`)
  // }
}